import type { ReactNode } from 'react';

/** Page title row: h1, optional one-paragraph lede, actions on the right. */
export function PageHeader({
  title,
  lede,
  children,
}: {
  title: ReactNode;
  lede?: ReactNode;
  children?: ReactNode;
}) {
  return (
    <div className="mb-[18px] flex flex-wrap items-end gap-3.5">
      <div className="min-w-0">
        <h1 className="m-0 text-[18px] font-semibold tracking-tight desk:text-[21px]">{title}</h1>
        {lede ? <p className="mt-[3px] mb-0 max-w-[62ch] text-[13px] text-ink-2">{lede}</p> : null}
      </div>
      {children ? (
        <div className="ml-auto flex flex-wrap items-center gap-2">{children}</div>
      ) : null}
    </div>
  );
}
